import { render, staticRenderFns } from "./PrivacyNotiShare.vue?vue&type=template&id=568ea980&scoped=true"
import script from "./PrivacyNotiShare.vue?vue&type=script&lang=js"
export * from "./PrivacyNotiShare.vue?vue&type=script&lang=js"
import style0 from "./PrivacyNotiShare.vue?vue&type=style&index=0&id=568ea980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568ea980",
  null
  
)

export default component.exports